//create a new component react?
import React from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

export const RadioGroupInput = ({ row, options, adicionalValues, onChange, inputName, readOnly = false }) => {
    const handleChange = (target) => {
        const { name, value } = target;
        const checked = adicionalValues?.includes(parseInt(value));

        if (!checked) {
            onChange(inputName, [...adicionalValues, parseInt(value)]);
        } else {
            onChange(inputName, adicionalValues.filter(a => a !== parseInt(value)));
        }
    }

    return (<>
        <FormControl margin='normal'>
            {options?.map((option) => (
                <FormControlLabel
                    key={option.value}
                    control={
                        <Radio
                            checked={adicionalValues?.includes(option.value)}
                            value={option.value}
                            onClick={(e) => handleChange(e.target)}
                        />
                    }
                    label={option.label}
                    disabled={(option.disabled ?? false) || readOnly} />
            ))}
        </FormControl>
    </>);
}
